import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// Register Service Worker for PWA with auto-update
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(registration => {
      console.log('[App] SW registered:', registration);

      // Check for updates every 30 minutes (industry standard)
      setInterval(() => {
        console.log('[App] Checking for updates...');
        registration.update();
      }, 30 * 60 * 1000); // 30 minutes
      
      // Also check when app becomes visible (user returns to app)
      document.addEventListener('visibilitychange', () => {
        if (!document.hidden) {
          console.log('[App] App visible, checking for updates...');
          registration.update();
        }
      });

      // Listen for updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[App] New service worker found!');

        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'activated') {
              console.log('[App] New version activated!');
              // Show update notification (non-intrusive)
              if (registration.waiting) {
                console.log('[App] Reloading to activate new version...');
              }
            }
          });
        }
      });
    }).catch(error => {
      console.log('[App] SW registration failed:', error);
    });

    // Listen for messages from service worker
    navigator.serviceWorker.addEventListener('message', (event) => {
      if (event.data && event.data.type === 'SW_UPDATED') {
        console.log('[App] New version available:', event.data.version);
        // Auto-refresh after 2 seconds to apply updates
        setTimeout(() => {
          console.log('[App] Refreshing to load new version...');
          window.location.reload();
        }, 2000);
      }
    });

    // Handle controller change (new SW took over)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      console.log('[App] New service worker activated, reloading...');
      window.location.reload();
    });
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
